<template>
  <div :class="{ 'black--text': !readonly }">
    <v-row v-if="costComponents.length > 0" dense no-gutters class="caption">
      <v-col :cols="readonly ? 8 : 7">{{ $t('bidCostType') }}</v-col>
      <v-col :cols="rateCols" class="text-right">{{ $t('rate') }}</v-col>
      <v-col v-if="!readonly" :cols="actionCols"/>
    </v-row>

    <v-row
    v-for="component in costComponents"
    :key="component.bidCostTypeId"
    dense
    no-gutters
    align="center"
    :class="component.bidCostTypeId === editingId ? 'primary--text font-weight-medium' : ''">
      <v-col :cols="readonly ? 8 : 7">{{ component.bidCostTypeName }}</v-col>
      <v-col :cols="rateCols" class="text-right">
        <MoneyTextField
        v-if="editableRates"
        class="mt-n3 mb-n5"
        :initialValue="component.rate"
        label=""
        dense
        @val-changed="changeRate(component, $event)"/>
        <template v-else>{{ formatMoney(component.rate) }}</template>
      </v-col>
      <v-col v-if="!readonly" :cols="actionCols" class="text-right">
        <Icon
        v-if="!editableRates"
        icon="mdi-pencil"
        iconColor="success"
        tabindex="0"
        :tooltipText="$t('editCostComponent')"
        @icon-clicked="$emit('edit', component)"/>
        <Icon
        icon="mdi-delete-forever"
        iconColor="error"
        :tooltipText="$t('removeCostComponent')"
        @icon-clicked="$emit('delete', component)"/>
      </v-col>
    </v-row>

    <template v-if="showTotal">
      <v-divider class="my-1"/>
      <v-row dense no-gutters>
        <v-col :cols="readonly ? 8 : 7" class="font-weight-bold">{{ $t('total') }}</v-col>
        <v-col :cols="rateCols" class="text-right font-weight-bold">{{ formatMoney(totalRate) }}</v-col>
        <v-col v-if="!readonly" :cols="actionCols"/>
      </v-row>
    </template>

    <NoData v-if="costComponents.length === 0" class="my-2">{{ $t('noCostsYet') }}</NoData>
  </div>
</template>

<script>
import { formatMoney } from '@/utils/NumericMutations'

export default {
  name: 'BidCostComponentList',

  components: {
    Icon: () => import('@/components/helper/Icon.vue'),
    NoData: () => import('@/components/core/NoData.vue'),
    MoneyTextField: () => import('@/components/helper/MoneyTextField.vue')
  },

  props: {
    costComponents: {
      type: Array,
      default: () => []
    },
    readonly: {
      type: Boolean,
      default: false
    },
    editingId: {
      type: Number,
      default: null
    },
    hideTotal: {
      type: Boolean,
      default: false
    },
    editableRates: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    rateCols () {
      return this.readonly || this.editableRates ? 4 : 3
    },

    actionCols () {
      return this.editableRates ? 1 : 2
    },

    showTotal () {
      return !this.hideTotal && this.costComponents.length > 1
    },

    totalRate () {
      return this.costComponents.reduce((total, c) => total + (c.rate ?? 0), 0)
    }
  },

  methods: {
    formatMoney,

    changeRate (component, rate) {
      if (rate !== component.rate) this.$emit('rate-changed', component, rate)
    }
  }
}
</script>
